// extracted by mini-css-extract-plugin
export var backupIcon = "_nu-1";
export var image = "_nu-0";